import React from "react";
import Update from "modules/assignmentRules/components/Update";

const AssignmentRulesUpdatePage = () => {
  return <Update />;
};

export default AssignmentRulesUpdatePage;
